import { ref } from 'vue';
import { defineStore } from 'pinia';
import { applyPatch } from 'fast-json-patch';

export const useEventActivityStore = defineStore('eventActivityStore', () => {
    const events = ref({});

    function addEventActivity(eventActivityModel) {
        this.events[eventActivityModel.id] = eventActivityModel;
    }

    function updateEventActivity(id, eventActivityModel) {
        this.events[id] = eventActivityModel;
    }

    function removeEventActivity(id) {
        delete this.events[id];
    }

    function applyJsonPatch(id, jsonPatch) {
        applyPatch(this.events[id], jsonPatch, false, true);
    }

    return {
        events,
        addEventActivity,
        updateEventActivity,
        removeEventActivity,
        applyJsonPatch
    }
})